import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { RoleService } from 'src/app/shared/auth/role.service';
import { HealthService, ServiceInfo } from 'src/app/services/health.service';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.css'
})

export class NavbarComponent implements OnInit {
	roles: string[];
	showPopup: boolean = false;
	services: ServiceInfo[] = [];

	constructor(
		private route: Router,
		private roleService: RoleService,
		private healthService: HealthService
	) {
		const storedRoles = localStorage.getItem('roles');
		this.roles = storedRoles ? storedRoles.split(',') : [];
	 }
	 
	ngOnInit() {
        this.roles = (localStorage.getItem('roles') || '')
            .split(',')
            .map(r => r.trim())
            .filter(Boolean);
        $.getScript('js/app.js');
        this.checkMenu();
        this.restoreSidebarState();
    }

	can(permission:string):boolean{
		return this.roleService.can(permission);
	}

	loadRoles() {
        const storedRoles = localStorage.getItem('roles');
        this.roles = storedRoles 
            ? storedRoles.split(',').map(r => r.trim()) 
            : [];
    }

	menuExpandColapse(): void {
		let element: any = document.getElementById("sidebarExpand");
		let ele: any = document.getElementById("mainTheme");
		const isCollapsed = element.classList.contains('sidebar-main-resized') || element.classList.contains('sidebar-mobile-expanded');

		if (isCollapsed) {
			ele.classList.remove("adjecent_content");
			localStorage.setItem('sidebarState', 'expanded');
		} else {
			ele.classList.add("adjecent_content");
			localStorage.setItem('sidebarState', 'collapsed');
		}
	}

	closeMobileSidebar(): void {
		document.getElementById('sidebarExpand')?.classList.remove('sidebar-mobile-expanded');
	}

	checkMenu() {
		let ele: any = document.getElementById('nav-item-submenu');
		let element: any = document.getElementById('nav-group-sub');
		if (this.route.url == '/category' || this.route.url == '/market') {
			if (!ele.classList.contains('nav-item-open')) {
				ele.classList.add("nav-item-open");
				element.classList.add("show");
			}
				
		} else {
			ele.classList.remove("nav-item-open");
			element.classList.remove("show");				
		}
	}

	restoreSidebarState() {
		const state = localStorage.getItem('sidebarState');
		let ele: any = document.getElementById("mainTheme");
		let sidebar: any = document.getElementById("sidebarExpand");
	
		// This assumes default is collapsed
		if (state === 'collapsed') {
			ele?.classList.add("adjecent_content");
			sidebar?.classList.add("sidebar-main-resized");
		} else {
			ele?.classList.remove("adjecent_content");
			sidebar?.classList.remove("sidebar-main-resized");
		}
	}

	togglePopup() {
		this.showPopup = !this.showPopup;
		if (this.showPopup) {
			this.healthService.getHealthDetail().subscribe({
				next: (services: ServiceInfo[]) => {
					this.services = services;
				}
			});
		}
	}
}
